import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";

export const LP = ({ children }) => (
  <p className="mt-4 text-sm leading-relaxed text-empire-mist">{children}</p>
);

export const LL = ({ items }) => (
  <ul className="mt-4 list-disc space-y-2 pl-5 text-sm leading-relaxed text-empire-mist">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

export const LMail = () => (
  <a href="mailto:contact@4empire.fr" className="text-empire-red transition-colors hover:text-empire-glow">
    contact@4empire.fr
  </a>
);

export default function LegalLayout({ testid, title, accent, description, sections }) {
  return (
    <main>
      <Seo title={`${title} ${accent || ""} — 4EMPIRE`} description={description} noindex />
      <section
        className="relative overflow-hidden bg-empire-black pb-14 pt-40 lg:pt-48"
        data-testid={`${testid}-header`}
      >
        <div className="absolute inset-0 bg-grid" aria-hidden="true" />
        <div
          className="halo-red pointer-events-none absolute -right-32 top-0 h-[320px] w-[320px] rounded-full"
          aria-hidden="true"
        />
        <div className="relative z-10 mx-auto max-w-4xl px-6 lg:px-10">
          <Reveal>
            <p className="font-grotesk text-xs uppercase tracking-[0.3em] text-empire-red">Legal</p>
            <h1
              className="mt-4 font-anton text-4xl uppercase leading-tight sm:text-5xl"
              data-testid={`${testid}-heading`}
            >
              {title} {accent && <span className="text-empire-red">{accent}</span>}
            </h1>
            {description && (
              <p className="mt-4 max-w-2xl text-sm leading-relaxed text-empire-mist">{description}</p>
            )}
          </Reveal>
        </div>
      </section>

      <section className="bg-empire-black pb-24 lg:pb-32" data-testid={`${testid}-content`}>
        <div className="mx-auto max-w-4xl px-6 lg:px-10">
          {sections.map((s, i) => (
            <Reveal
              key={s.heading}
              className={i === 0 ? "" : "mt-12 border-t border-white/10 pt-12"}
            >
              <h2
                className="font-anton text-xl uppercase tracking-wide"
                data-testid={`${testid}-section-${i + 1}`}
              >
                {s.heading}
              </h2>
              {s.body}
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
